export const SCENARIO_TIME_GRAPH_REQUEST = 'SCENARIO_TIME_GRAPH_REQUEST';
export const SCENARIO_TIME_GRAPH_RESPONSE = 'SCENARIO_TIME_GRAPH_RESPONSE';
export const SCENARIO_TIME_GRAPH_RESET = 'SCENARIO_TIME_GRAPH_RESET';
